import React from 'react';

import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';
import Form, { FormProps } from 'carbon-react/lib/components/form';

export interface SfaContentFormProps extends FormProps {
  verticalCenter?: boolean;
}

export const SfaContentForm = ({ children, verticalCenter, saveButton, ...props }: SfaContentFormProps) => {
  const saveBtn = saveButton || (
    <div style={{ visibility: 'hidden' }}>
      <Button buttonType="primary" type="button" aria-hidden disabled>
        {' '}
      </Button>
    </div>
  );

  return (
    <Form stickyFooter saveButton={saveBtn} {...props}>
      {verticalCenter ? (
        <Box alignItems="center" display="flex" flexDirection="column" height="100%" justifyContent="center">
          <Box px={3} py={10}>
            {children}
          </Box>
        </Box>
      ) : (
        <Box px={3} py={10}>
          {children}
        </Box>
      )}
    </Form>
  );
};
